import { render } from "./SelectOrderClientType.vue?vue&type=template&id=6608f6e0&scoped=true&ts=true"
import script from "./SelectOrderClientType.vue?vue&type=script&lang=ts"
export * from "./SelectOrderClientType.vue?vue&type=script&lang=ts"

import "./SelectOrderClientType.vue?vue&type=style&index=0&id=6608f6e0&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution.Cashier/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6608f6e0"]])

export default __exports__